'use strict';

require("core-js/modules/es6.promise");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

Object.defineProperty(exports, '__esModule', {
  value: true
});

require('revalidator');

var ValidatorService = require('./ValidatorService.js');

var AjaxAction =
/*#__PURE__*/
function () {
  function AjaxAction(endpointService, endpointDefinition) {
    this.endpointService = endpointService;
    this.endpointDefinition = endpointDefinition;
  }
  /**
   * Executes an action to recover a list of centers.
   * @param {Object} options Performs parameter validation on them if the endpoint definition contains a params
   *                         object with a revalidator-compatible specification.
   * @returns {Promise} A Promise that resolves when the process of recovering the data is finished.
   */


  var _proto = AjaxAction.prototype;

  _proto.invoke = function invoke(options) {
    // single out the URL path parameters, to be added to the AJAX path
    var endpointPath = this.endpointDefinition.path;
    var endpointParams = this.endpointDefinition.params;
    var endpointUrlParams = this.endpointDefinition.urlParams;
    var requestParams;

    if (this.isEmptyObject(endpointUrlParams)) {
      requestParams = options;
    } else {
      requestParams = {};

      for (var _i = 0, _Object$keys = Object.keys(endpointUrlParams); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var paramName = endpointUrlParams[key];
        var paramValue = options[paramName];

        if (!paramValue) {
          throw new Error("AjaxAction#invoke: undefined param \"" + paramName + "\"");
        }

        endpointPath = endpointPath.replace(key, paramValue);
      } // single out the request parameters, to be sent with the AJAX request


      var urlParamNames = Object.values(endpointUrlParams);
      Object.keys(options).forEach(function (key) {
        if (!urlParamNames.includes(key)) {
          requestParams[key] = options[key];
        }
      });
    }

    if (!this.isEmptyObject(endpointParams)) {
      var validator = new ValidatorService.ValidatorService({
        data: requestParams,
        validation: endpointParams
      });
      var validation = validator.validate();

      if (!validation.valid) {
        return Promise.reject(validation);
      }
    }

    if (this.endpointDefinition.activeRequestConfig) {
      this.endpointService.httpApi.activeRequestConfig = this.endpointDefinition.activeRequestConfig;
    }

    var path = "" + this.endpointService.apiPrefix + endpointPath;
    return this.endpointService.run(this.endpointDefinition.method, path, requestParams);
  };

  _proto.isEmptyObject = function isEmptyObject(object) {
    object = object || {};
    return Object.keys(object).length === 0;
  };

  return AjaxAction;
}();

exports.AjaxAction = AjaxAction;